module.exports = __webpack_public_path__ + "static/media/Background0.7d94f94c.jpg";